<app-banner [heading]="'OUR INFRA - BIOLOGY LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 " >
            
			<img src="assets/img/infra/sciencelabs/biology-lab-1.jpg" class="img-fluid" alt="best school in kurukshetra">
            </div> 

             <div class="col-lg-6  pt-5 pt-lg-0" > 
              <p> <br>One Doctor can save many lives &amp; can contribute more in our society , We are trying our
			  level best to explore more life saving professionals .<br><br>The best faculty of Tagore Global
			  School is trying to recognize potential of our future Doctors &amp; Medical Professionals.
			  
			  </p>
              
            </div>
          </div>
		</div>
      
	</section><!-- End About Section -->
	
  </main>